import { reactivateRestaurantPause, saveRestaurantPause } from '../graphql/mutations';
import {
  getRestaurantPauseOffers,
  getLifetimeDetails,
  getRestaurantPauseFees,
  getRestaurantPauseProjected,
} from '../graphql/queries';
import { makeApiAction } from './actions';

export const getLifetimeDetailsAction = () => (dispatch) => {
  const action = 'FETCH_LIFETIME_DETAILS';

  dispatch(
    makeApiAction(
      action,
      getLifetimeDetails,
      {},
      null,
      'getLifetimeDetails',
      true,
      null,
      null,
      null,
      false,
    ),
  );
};

export const getPauseFeesAction = () => (dispatch) => {
  const action = 'FETCH_PAUSE_FEES';

  dispatch(
    makeApiAction(
      action,
      getRestaurantPauseFees,
      {},
      null,
      'getRestaurantPauseFees',
      true,
      null,
      null,
      null,
      false,
    ),
  );
};

export const getRestaurantPauseProjectedAction = () => (dispatch) => {
  const action = 'FETCH_PAUSE_PROJECTION';

  dispatch(
    makeApiAction(
      action,
      getRestaurantPauseProjected,
      {},
      null,
      'getRestaurantPauseProjected',
      true,
      null,
      null,
      null,
      false,
    ),
  );
};

/**
 * Do they have an active PAUSE offer.
 * Part of the cancellation flow if the venue accepted the one week free EatClub offer
 * Not to be confused with Offers (Deals)
 * @returns {(function(*): void)|*}
 */
export const getRestaurantPauseOffersAction = () => (dispatch) => {
  const action = 'FETCH_ACTIVE_OFFERS';

  dispatch(
    makeApiAction(
      action,
      getRestaurantPauseOffers,
      {},
      null,
      'getRestaurantPauseOffers',
      true,
      null,
      null,
      null,
      false,
    ),
  );
};

export const saveRestaurantPauseAction = (pauseData) => (dispatch) => {
  const action = 'SAVE_RESTAURANT_PAUSE';

  const variables = {
    reason: pauseData?.reason ?? null,
    reasonDetails: pauseData?.reasonDetails ?? null,
    reasonFreeText: pauseData?.reasonFreeText ?? null,
    timeframe: pauseData?.timeframe ?? null,
    email: pauseData?.email ?? null,
    amCallDates: pauseData?.amCallDates ?? null,
    amCallDatePeriod: pauseData?.amCallDatePeriod ?? null,
    offerAccepted: pauseData?.offerAccepted ?? null,
    hasDebt: pauseData?.hasDebt || false,
    // assignedToStaffId: pauseData?.assignedToStaffId ?? null,
    // saveLikelihood: pauseData?.saveLikelihood ?? null,
  };

  dispatch(
    makeApiAction(
      action,
      saveRestaurantPause,
      variables,
      null,
      'saveRestaurantPause',
      true,
      null,
      null,
      { hasDebt: variables?.hasDebt },
      false,
    ),
  );
};

export const reactivateRestaurantPauseAction = () => (dispatch) => {
  const action = 'REACTIVATE_RESTAURANT_PAUSE';

  dispatch(
    makeApiAction(action, reactivateRestaurantPause, {}, null, 'reactivateRestaurantPause', true),
  );
};
